import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { ThirdPartyPayroll } from './third-party-payroll.model';
import * as ThirdPartyPayrollActions from './third-party-payroll.actions';
import * as fromThirdPartyPayroll from './third-party-payroll.reducer';
import { PayrollCode } from './payroll-code.model';
import { FileFormatModel } from './file-format.model';
import { ReimbursementPaycode } from './reimbursement-paycode.model';

export const thirdPartyPayrollFeatureKey = 'thirdPartyPayroll';

export interface State extends EntityState<ThirdPartyPayroll> {
    // additional entities state properties
    // [fromThirdPartyPayroll.thirdPartyPayrollFeatureKey]: fromThirdPartyPayroll.State;
    payrollCodes: PayrollCode[];
    fileFormats: FileFormatModel[];
    reimbursementPaycodes: ReimbursementPaycode[];
}

export const adapter: EntityAdapter<ThirdPartyPayroll> = createEntityAdapter<ThirdPartyPayroll>();

export const initialState: State = adapter.getInitialState({
    // additional entity state properties
    payrollCodes: [],
    fileFormats: [],
    reimbursementPaycodes: []
});

export const reducer = createReducer(
    initialState,
    on(ThirdPartyPayrollActions.addThirdPartyPayroll, (state, action) =>
        adapter.addOne(action.thirdPartyPayroll, state)
    ),
    on(ThirdPartyPayrollActions.upsertThirdPartyPayroll, (state, action) =>
        adapter.upsertOne(action.thirdPartyPayroll, state)
    ),
    on(ThirdPartyPayrollActions.addThirdPartyPayrolls, (state, action) =>
        adapter.addMany(action.thirdPartyPayrolls, state)
    ),
    on(ThirdPartyPayrollActions.upsertThirdPartyPayrolls, (state, action) =>
        adapter.upsertMany(action.thirdPartyPayrolls, state)
    ),
    on(ThirdPartyPayrollActions.updateThirdPartyPayroll, (state, action) =>
        adapter.updateOne(action.thirdPartyPayroll, state)
    ),
    on(ThirdPartyPayrollActions.updateThirdPartyPayrolls, (state, action) =>
        adapter.updateMany(action.thirdPartyPayrolls, state)
    ),
    on(ThirdPartyPayrollActions.deleteThirdPartyPayroll, (state, action) =>
        adapter.removeOne(action.id, state)
    ),
    on(ThirdPartyPayrollActions.deleteThirdPartyPayrolls, (state, action) =>
        adapter.removeMany(action.ids, state)
    ),
    on(ThirdPartyPayrollActions.loadThirdPartyPayrolls, (state, action) =>
        adapter.setAll(action.thirdPartyPayrolls, state)
    ),
    on(ThirdPartyPayrollActions.clearThirdPartyPayrolls, state =>
        adapter.removeAll(state)
    ),
    on(ThirdPartyPayrollActions.loadPayrollCodes, (state, action) => ({
        ...state,
        payrollCodes: [
            ...state.payrollCodes.filter(
                x =>
                    !action.payrollCodes
                        .map(y => y.Paycodeid)
                        .includes(x.Paycodeid)
            ),
            ...action.payrollCodes
        ]
    })),
    on(ThirdPartyPayrollActions.deletePayrollCodes, (state, action) => ({
        ...state,
        payrollCodes: [
            ...state.payrollCodes.filter(
                x => !action.payrollIds.includes(x.Paycodeid)
            )
        ]
    })),
    on(ThirdPartyPayrollActions.loadFileFormat, (state, action) => ({
        ...state,
        fileFormats: [
            ...state.fileFormats.filter(
                x => !action.fileFormats.map(a => a.Fieldid).includes(x.Fieldid)
            ),
            ...action.fileFormats
        ]
    })),
    on(ThirdPartyPayrollActions.loadReimbursementPaycodes, (state, action) => ({
        ...state,
        reimbursementPaycodes: action.reimbursementPaycodes
    }))
);
